import { useEffect, useState } from "react";

const links = [
  { label: "最新热瓜", href: "#latest" },
  { label: "重磅关注", href: "#featured" },
  { label: "今日瓜线", href: "#timeline" },
  { label: "吃瓜FAQ", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "border-b border-background-200 bg-background-50/95 backdrop-blur"
          : "bg-transparent"
      }`}
    >
      <div className="flex w-full items-center justify-between gap-4 px-4 py-3 md:px-6">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-broadcast-fill text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-black text-foreground-950">
              大瓜预警
            </span>
            <span className="text-[10px] tracking-[0.35em] text-primary-700">
              BIG MELON ALERT
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="rounded-full px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-primary-800 whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#submit"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            匿名投稿
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-900 hover:bg-secondary-100 md:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-800 hover:bg-secondary-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#submit"
              onClick={() => setOpen(false)}
              className="mt-1 inline-flex items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
            >
              匿名投稿
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}